const WebToLeadFormClass = 'web-to-lead-form';
const HoneypotInputName = 'preferred_form_of_contact_for_follow_up';

const initHoneypot = (form) => {
  const hasHoneypot = form.querySelector(`input[name="${HoneypotInputName}"]`);
  if (hasHoneypot) return;

  const honeypot = document.createElement('input');
  honeypot.type = 'hidden';
  honeypot.style.display = 'none';
  honeypot.name = HoneypotInputName;
  honeypot.value = '';
  const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

  if (submitButton) {
    form.insertBefore(honeypot, submitButton);
  } else {
    form.appendChild(honeypot);
  }

  form.addEventListener('submit', (e) => {
    if (honeypot.value) {
      e.preventDefault();
    }
  });
};

const initHoneypots = (root) => {
  const forms = root.querySelectorAll(`form[class*="${WebToLeadFormClass}"]`);

  forms.forEach(initHoneypot);
};

(async () => {
  if (typeof window === 'undefined') return;

  document.addEventListener('DOMContentLoaded', () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type !== 'childList') return;
        [...mutation.addedNodes]
          .filter((node) => node instanceof Element)
          .forEach((node) => initHoneypots(node));
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    initHoneypots(document);
  });
})();
